<p class="text-darkGray text-center">Cambio de contraseña</p>
<form class="space-y-4 md:space-y-6">
  <div>
    <label for="password" appFormLabel>Contraseña</label>
    <input [(ngModel)]="password" type="password" name="email" id="password" appFormInputText placeholder="*********" required>
  </div>
  <div>
    <label for="password_confirmation" appFormLabel>Confirmación contraseña</label>
    <input [(ngModel)]="password_confirmation" type="password" name="email" id="password_confirmation" appFormInputText placeholder="*********" required>
  </div>
  <!-- <div *ngIf="successMessage" class="p-4 mb-4 text-sm text-darkGray rounded-lg bg-green" role="alert">
     {{ successMessage }}
   </div>
   <div *ngIf="errorMessage" class="p-4 mb-4 text-sm text-red-800 rounded-lg bg-red-50" role="alert">
     {{ errorMessage }}
   </div>-->
  <button [disabled]="loading" (click)="resetPassword()" type="submit" class="w-full disabled:bg-darkGray text-white bg-primary hover:opacity-85 focus:ring-4 focus:outline-none focus:ring-primary font-medium rounded-lg text-sm px-5 py-2.5 text-center ">
    Recuperar
  </button>
</form>
